import React, { useState } from "react";
import RangeSelection from "./RangeSelection";
import withMiddleware from "../../../../middleware/index";
import { formatNumber } from "../../../../utils";
import DataTable from "../../../../components/data-table";
import { Tooltip } from "@material-ui/core";

const columns = [
  {
    headerName: "Name",
    minWidth: 200,
    field: "org_name",
    renderCell: ({ row }) => {
      const name = row?.org_name;
      return (
        <Tooltip title={name}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <img src={`https://ui-avatars.com/api/?rounded=true&size=35&background=random&name=${name}`} alt={name} />
            <span>{name}</span>
          </div>
        </Tooltip>
      );
    },
    sortable: false,
  },
  {
    headerName: "Users",
    description: "All time total number of users in this organization",
    field: "total_users",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Active Users",
    description: "Total number of users that have took at least one reading in the selected time range",
    field: "total_users_active",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Readings",
    description: "Total number of morning, anytime, biofeedback, mindfulness and self-compassion sessions in the selected time range",
    field: "total_readings",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Biofeedback",
    field: "exercise_sessions",
    description: "Total number of biofeedback sessions in the selected time range",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Mindfulness",
    field: "mindfulness_sessions",
    description: "Total number of mindfulness sessions in the selected time range",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Self-Compassion",
    description: "Total number of self-compassion sessions in the selected time range",
    field: "plan_sessions",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Morning",
    description: "Total number of morning readings in the selected time range",
    field: "morning_readings",
    valueFormatter: ({ value }) => formatNumber(value),
  },
  {
    headerName: "Anytime",
    description: "Total number of anytime readings in the selected time range",
    field: "anytime_readings",
    valueFormatter: ({ value }) => formatNumber(value),
  },
];

function TopOrgs(props) {
  const [range, setRange] = useState({ label: "30 days", key: "30-days" });
  const currentRange = range?.label;
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2
          style={{
            marginBottom: 0,
          }}
        >
          Top Organizations in <u>{currentRange}</u>
        </h2>
        <RangeSelection onRangeChange={(newRange) => setRange(newRange)} activeRange={range} />
      </div>
      <p
        style={{
          marginTop: 0,
        }}
      >
        Who have most number of users, morning & anytime readings, biofeedback, mindfulness and self compassion sessions.
      </p>
      <DataTable
        columns={columns}
        service={props.service}
        apiEndpoint="/analytics/top_orgs_by_users"
        onRowClick={(row) => alert("This is yet to be implemented!!")}
        isServerSideSorting={false}
        isServerSidePagination={false}
        defaultSortModel={[{ field: "total_users_active", sort: "desc" }]}
        apiParams={{ range: range?.key }}
      />
    </>
  );
}

export default withMiddleware(TopOrgs);
